import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextFormatStrikethrough24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconTextFormatStrikethrough24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.5 4H20v3.75a.75.75 0 0 1-1.5 0V5.5H13V9a.75.75 0 0 1-1.5 0V5.5H6v2.25a.75.75 0 0 1-1.5 0zM13 16.5a.75.75 0 0 0-1.5 0v2H9.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5H13zM5.25 12a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextFormatStrikethrough24);
